export enum XpoFacetRangeFilterTexts {
  Under = 'Under',
  Over = 'Over',
};
